document.addEventListener('DOMContentLoaded', function () {
    const subscriptionWrapper = document.querySelector('.product-subscription-pdp');
    if (!subscriptionWrapper) return;

    let isSubscriptionMode = true;

    const oneTimePurchase = subscriptionWrapper.querySelector('.product-subscription__item[data-place="0"]');
    const subscribeAndSaveTrigger = subscriptionWrapper.querySelector('.subscription-collapsable-trigger');
    const subscriptionOptionsContainer = subscriptionWrapper.querySelector('.product-subscription-options__cont');
    const dropdown = subscriptionWrapper.querySelector('.product-subscription-dropdown');
    const dropdownTrigger = dropdown?.querySelector('.product-subscription-dropdown__trigger');
    const dropdownSelected = dropdown?.querySelector('.product-subscription-dropdown__selected');
    const frequencySelect = subscriptionWrapper.querySelector('#pdp-delivery-frequency');
    const oneTimeRadio = oneTimePurchase?.querySelector('input[type="radio"]');
    const subscribeRadio = subscribeAndSaveTrigger?.querySelector('input[type="radio"]');
    const subscriptionPlanItems = dropdown?.querySelectorAll('.product-subscription-options__collapsable .product-subscription__item');

    function syncRadios(subscribe) {
        if (oneTimeRadio) oneTimeRadio.checked = !subscribe;
        if (subscribeRadio) subscribeRadio.checked = subscribe;
    }

    function syncFrequencySelect(item) {
        if (!frequencySelect || !item) return;
        const match = Array.from(frequencySelect.options).find((option) => option.dataset.place === item.dataset.place);
        if (match && frequencySelect.value !== match.value) frequencySelect.value = match.value;
    }

    // Set initial selling plan to first subscription option
    const sellingPlanInput = document.getElementById('selling_plan');
    const firstSubscriptionPlan = subscriptionWrapper.querySelector('.product-subscription-options__collapsable .product-subscription__item[data-place="1"]');
    if (sellingPlanInput && firstSubscriptionPlan && firstSubscriptionPlan.dataset.sellingPlan) {
        sellingPlanInput.value = firstSubscriptionPlan.dataset.sellingPlan;
        // Update dropdown selected text to match first plan
        const firstPlanTitle = firstSubscriptionPlan.querySelector('.product-subscription__title');
        if (dropdownSelected && firstPlanTitle) {
            dropdownSelected.textContent = firstPlanTitle.textContent.trim();
        }
    }

    function activateOneTimePurchase() {
        isSubscriptionMode = false;

        const sellingPlanInput = document.getElementById('selling_plan');
        if (sellingPlanInput) {
            sellingPlanInput.value = '';
        }

        oneTimePurchase.classList.add('product-subscription__item--active');
        subscribeAndSaveTrigger.classList.remove('product-subscription__item--active');
        syncRadios(false);

        subscriptionPlanItems.forEach((item) => {
            item.classList.remove('product-subscription__item--active');
            item.setAttribute('aria-selected', 'false');
        });

        dropdown.classList.remove('active');
        dropdown.classList.remove('open');
        if (dropdownTrigger) dropdownTrigger.setAttribute('aria-expanded', 'false');

        subscriptionOptionsContainer.classList.remove('active');

        // Update badge amounts and visibility for one-time purchase (cycle 0)
        if (typeof updateBottlePriceOriginal === 'function') {
            updateBottlePriceOriginal(0);
        }
    }

    function activateSubscriptionMode() {
        isSubscriptionMode = true;

        oneTimePurchase.classList.remove('product-subscription__item--active');
        subscribeAndSaveTrigger.classList.add('product-subscription__item--active');
        syncRadios(true);

        dropdown.classList.add('active');

        subscriptionOptionsContainer.classList.add('active');

        // Update badge amounts and visibility for subscription mode (cycle 1 = first subscription plan)
        if (typeof updateBottlePriceOriginal === 'function') {
            updateBottlePriceOriginal(1);
        }

        if (subscriptionPlanItems && subscriptionPlanItems.length > 0) {
            setTimeout(() => {
                const firstPlan = subscriptionPlanItems[0];

                const sellingPlanInput = document.getElementById('selling_plan');
                if (sellingPlanInput && firstPlan.dataset.sellingPlan) {
                    sellingPlanInput.value = firstPlan.dataset.sellingPlan;
                }

                subscriptionPlanItems.forEach((opt) => {
                    opt.classList.remove('product-subscription__item--active');
                    opt.setAttribute('aria-selected', 'false');
                });
                firstPlan.classList.add('product-subscription__item--active');
                syncFrequencySelect(firstPlan);

                const titleEl = firstPlan.querySelector('.product-subscription__title');
                if (dropdownSelected && titleEl) {
                    dropdownSelected.textContent = titleEl.textContent.trim();
                }

                updateDynamicSubscriptionPrice(firstPlan);
            }, 100);
        }
    }

    function updateDynamicSubscriptionPrice(item) {
        const dynamicPriceEl = subscriptionWrapper.querySelector('.dynamic-subscription-price');
        const itemPriceEl = item.querySelector('.product-subscription__price .price--sale');
        if (dynamicPriceEl && itemPriceEl) {
            dynamicPriceEl.textContent = itemPriceEl.textContent.trim();
        }
    }

    function selectSubscriptionPlan(item, closeDropdown = true) {
        isSubscriptionMode = true;

        const sellingPlanInput = document.getElementById('selling_plan');
        if (sellingPlanInput && item.dataset.sellingPlan) {
            sellingPlanInput.value = item.dataset.sellingPlan;
        }

        oneTimePurchase.classList.remove('product-subscription__item--active');
        subscribeAndSaveTrigger.classList.add('product-subscription__item--active');
        syncRadios(true);
        syncFrequencySelect(item);

        dropdown.classList.add('active');

        subscriptionOptionsContainer.classList.add('active');

        subscriptionPlanItems.forEach((opt) => {
            opt.classList.remove('product-subscription__item--active');
            opt.setAttribute('aria-selected', 'false');
        });
        item.classList.add('product-subscription__item--active');
        item.setAttribute('aria-selected', 'true');

        const titleEl = item.querySelector('.product-subscription__title');
        if (dropdownSelected && titleEl) {
            dropdownSelected.textContent = titleEl.textContent.trim();
        }

        // Update badge amounts based on the selected subscription plan's cycle
        if (typeof updateBottlePriceOriginal === 'function' && item.dataset.place) {
            updateBottlePriceOriginal(parseInt(item.dataset.place));
        }

        updateDynamicSubscriptionPrice(item);

        if (closeDropdown) {
            dropdown.classList.remove('open');
        }
    }

    function ensureTriggerActiveWhenSubscriptionSelected() {
        const hasActiveSubscription = Array.from(subscriptionPlanItems).some((item) =>
            item.classList.contains('product-subscription__item--active')
        );

        if (hasActiveSubscription) {
            isSubscriptionMode = true;
            oneTimePurchase.classList.remove('product-subscription__item--active');
            subscribeAndSaveTrigger.classList.add('product-subscription__item--active');
            dropdown.classList.add('active');

            const activeItem = Array.from(subscriptionPlanItems).find((item) =>
                item.classList.contains('product-subscription__item--active')
            );
            if (activeItem) {
                const titleEl = activeItem.querySelector('.product-subscription__title');
                if (dropdownSelected && titleEl) {
                    dropdownSelected.textContent = titleEl.textContent.trim();
                }
            }
        }
    }

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                ensureTriggerActiveWhenSubscriptionSelected();
            }
        });
    });

    subscriptionPlanItems.forEach(function (item) {
        observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    oneTimePurchase.addEventListener('click', function (e) {
        activateOneTimePurchase();
    });

    subscribeAndSaveTrigger.addEventListener('click', function (e) {
        if (!isSubscriptionMode) {
            activateSubscriptionMode();
        }
    });

    if (frequencySelect) {
        frequencySelect.addEventListener('change', function () {
            const place = frequencySelect.options[frequencySelect.selectedIndex]?.dataset.place;
            const item = Array.from(subscriptionPlanItems || []).find((plan) => plan.dataset.place === place);
            if (item) selectSubscriptionPlan(item);
        });
    }

    if (oneTimeRadio) {
        oneTimeRadio.addEventListener('change', function () {
            if (oneTimeRadio.checked) activateOneTimePurchase();
        });
    }

    if (subscribeRadio) {
        subscribeRadio.addEventListener('change', function () {
            if (subscribeRadio.checked && !isSubscriptionMode) activateSubscriptionMode();
        });
    }

    if (subscriptionPlanItems) {
        subscriptionPlanItems.forEach(function (item) {
            item.addEventListener('click', function (e) {
                selectSubscriptionPlan(item);
                if (dropdownTrigger) dropdownTrigger.setAttribute('aria-expanded', 'false');
            });
            item.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    selectSubscriptionPlan(item);
                    if (dropdownTrigger) dropdownTrigger.setAttribute('aria-expanded', 'false');
                }
            });
        });
    }

    oneTimePurchase.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activateOneTimePurchase();
        }
    });

    subscribeAndSaveTrigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!isSubscriptionMode) activateSubscriptionMode();
        }
    });

    document.addEventListener('click', function (e) {
        if (dropdown && !dropdown.contains(e.target)) {
            dropdown.classList.remove('open');
            if (dropdownTrigger) dropdownTrigger.setAttribute('aria-expanded', 'false');
        }
    });

    ensureTriggerActiveWhenSubscriptionSelected();
});
